import React, { useMemo, useState } from 'react';

import { FilterButton } from '@components/Flows/Filters/FilterButton';
import Filters from '@components/Transactions/Filters';
import { AppliedFilters } from '@containers/transactions';
import { hasNonEmptyFilters } from '@containers/transactions/helpers';

export interface TransactionsFiltersProps {
  countryList: { label: string; value: string }[];
  appliedFilters: AppliedFilters;
  handleApplyFilters: (filters: object) => void;
}

const TransactionsFilters = (props: TransactionsFiltersProps) => {
  const { countryList, appliedFilters, handleApplyFilters } = props;

  const [showFilter, setShowFilter] = useState<boolean>(false);

  const hasAppliedFilters = useMemo(() => {
    return hasNonEmptyFilters(appliedFilters as AppliedFilters);
  }, [appliedFilters]);

  const toogleFilterView = () => {
    setShowFilter((prev) => !prev);
  };

  return (
    <>
      <FilterButton hasAppliedFilters={hasAppliedFilters} onClick={toogleFilterView} />
      <Filters
        showFilter={showFilter}
        toogleFilterView={toogleFilterView}
        countryList={countryList}
        appliedFilters={appliedFilters}
        handleApplyFilters={handleApplyFilters}
      />
    </>
  );
};

export default TransactionsFilters;
